import type {
  ProblemScoringForViewOption,
  ProblemScoringViewOption,
} from '../@trait/ProblemScoringViewOption.trait'

type ViewOption = ProblemScoringViewOption<'학습모듈' | 'NOT_학습모듈'>

/**
 * 헤더 "답" 영역 잠금 문구 표시 여부.
 * - 시험 응시 중 → 잠금
 * - 시험 RESOLVED → 잠금 해제
 * - 학부모 → 학부모정답해설공개(=채점후정답해설공개) 단독 시그널, 제출/미제출 무관
 * - 미제출 → 잠금 안 함 (학생)
 * - 자기주도학습 → 잠금 안 함
 * - 그 외 → 채점후정답해설공개 플래그 따름
 */
export const isAnswerLocked = (
  viewOption: ViewOption,
  problemScoring: ProblemScoringForViewOption,
) => {
  if (viewOption.isExamInProgress) return true
  if (viewOption.content.kind === 'EXAM') return false
  // 학부모는 베이직 정책 의도 — 학부모정답해설공개 단독으로 답 노출 결정 (제출/미제출 분기 X)
  if (viewOption.isParentView) return !viewOption.studentAppSetting?.채점후정답해설공개
  if (!problemScoring.isSubmitted) return false
  if (viewOption.isSelfLearning) return false
  return !viewOption.studentAppSetting?.채점후정답해설공개
}

/** 잠금 문구에 "풀이 영상" 단어 포함 여부 */
export const isVideoLocked = (viewOption: ViewOption) => {
  if (viewOption.content.kind === 'EXAM') return false
  if (viewOption.isVideoRestricted) return false
  return !viewOption.studentAppSetting?.채점후문풀동공개
}

/** 헤더 "풀이동영상" 버튼 노출 (제출 전 한정) */
export const showVideoButton = (
  viewOption: ViewOption,
  problemScoring: ProblemScoringForViewOption,
) => {
  if (viewOption.isSelfLearning) return false
  if (problemScoring.isSubmitted) return false
  if (!viewOption.studentAppSetting?.채점전문풀동공개) return false
  if (problemScoring.isAutoScoring) return true
  return !!viewOption.studentAppSetting?.일반채점_채점전정답공개
}
